// extracted by mini-css-extract-plugin
export default {"root":"HrKC8p53G6tViF_zUSbQ"};